

// var now = moment();
// var time_left = moment(end_of_day - now).format("HH:mm:ss");
// $("#time_left").click( function() {
// 	$(this).text(time_left);	
// });

$(document).ready(function() {
	if (ShouldDisplayBanner()) {
		$("#order_banner").attr("class", "order-banner");
		CalculateCountdownTimer();
		setTimeout(DisplayBanner, 1500);
	} else {
		$("#order_banner").attr("class", "blank-banner");
	}
});

function toggleBanner() {
	var banner_height = $("#order_banner").outerHeight();
	console.log(banner_height);
	$("#order_banner").slideUp();
	if ($("#mobile_nav").length != 0) {
		var mob_menu_top = parseInt($("#mobile_nav").css("top"), 10);
		console.log(mob_menu_top);
		$("#mobile_nav").css("top", mob_menu_top - banner_height);
		var scroll_offset = $(".navbar-content").outerHeight() + 70;
		$('.scrollspy').scrollSpy({
	        throttle: 200,
	        scrollOffset: scroll_offset
      	});
	}
}

function ShouldDisplayBanner() {
	var current_time = moment().format("x");
	var start_time = new Date();
	start_time.setHours(15,30,00,000);

	if (current_time >= start_time) {
		return true;
	} else {
		return false;
	}
}

function CalculateCountdownTimer() {
	var end_of_day = moment().endOf("day").format("x");

	// var time_now = moment().format("x");

	console.log(end_of_day);

	//console.log(time_now);

	// Update the count down every 1 second
	var x = setInterval(function() {

		// Get todays date and time
		var now = moment().format("x");

		// Find the distance between now an the count down date
		var distance = end_of_day - now;

		// Time calculations for days, hours, minutes and seconds
		// var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);

		if (hours < 10) {
		  hours = "0" + hours;
		}

		if (minutes < 10) {
		  minutes = "0" + minutes;
		}

		if (seconds < 10) {
		  seconds = "0" + seconds;
		}

		// Display the result in the element with id="demo"
		document.getElementById("time_left").innerHTML = hours + "H "
		+ minutes + "M " + seconds + "S";

		         
		// If the count down is finished, write some text 
		if (distance < 0) {
		  clearInterval(x);
		  document.getElementById("time_left").innerHTML = "EXPIRED";
		}
	}, 1000);
}	

function DisplayBanner() {
	$("#order_banner").slideDown();
}